import { Stack, StackProps, Typography } from '@mui/material';
import React from 'react';

import Image from 'components/Image';

// ----------------------------------------------------------------------

interface EmptyContentProps extends StackProps {
    title: string;
    img?: string;
    description?: string;
}

export default function EmptyContent({ title, description, img, sx, ...other }: EmptyContentProps) {
    return (
        <Stack
            alignItems='center'
            justifyContent='center'
            sx={{
                height: 1,
                textAlign: 'center',
                p: theme => theme.spacing(8, 2),
                ...sx,
            }}
            {...other}
        >
            <Image
                disabledEffect
                alt='empty content'
                src={img || '/assets/illustrations/illustration_empty_content.svg'}
                sx={{ height: 160, mb: 3 }}
            />

            <Typography variant='h6'>{title}</Typography>

            {description && (
                <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                    {description}
                </Typography>
            )}
        </Stack>
    );
}
